/******************************************
 *
 INSTALAR MUI CON:
 *  npm install @mui/material @emotion/react @emotion/styled
 *
 * https://mui.com/material-ui/getting-started/installation/
 *
 */

import '../../CSS/Estilo.css';
import * as React from 'react';
import logoXadnem from '../../avatar.png'
import logoFrater from '../../logoFrater.png'
import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/system/Box';
import Typography from '@mui/material/Typography';

export default function ToolBar({modo,estilo,paginas,gadgets}) {

    function btClicked(ev) {
        if (ev.target.id === 'Área privada')
            window.location = modo === 'oraxulux' ? "/login/?modo=oraxulux":"/login/?modo=frater";
        else if (ev.target.id === 'Inicio')
            window.location = modo === 'oraxulux' ? "/?modo=oraxulux":"/?modo=frater";
        else if(ev.target.id === 'Sobre nosotros'){
            window.location='/sobreNosotros';
        }
        else if(ev.target.id === 'Contacto'){
            window.location = modo === 'oraxulux' ? "/Contacto/?modo=oraxulux":"/Contacto/?modo=frater";
        }
        else if(ev.target.id === 'Noticias y Actividades'){
            window.location='/noticias';
        }
        else if (ev.target.id === 'Usuarios') {
            localStorage.setItem('Gestion', 'Usuarios');
            window.location = modo === 'oraxulux' ? "/admin?modo=oraxulux":"/admin?modo=frater";
            //window.location = '/admin';
        } else if (ev.target.id === 'Ficheros') {
            window.location = modo === 'oraxulux' ? "/admin?modo=oraxulux":"/admin?modo=frater";
            localStorage.setItem('Gestion', 'Ficheros');
            //window.location = '/admin';
        }
        else if(ev.target.id === 'Editar perfil'){
            localStorage.setItem('Gestion','Editar perfil')
            window.location = modo === 'oraxulux' ? "/admin?modo=oraxulux":"/admin?modo=frater";
            //window.location='/admin';
        }
        else if(ev.target.id === 'Documentos'){
            alert("En construcción");
        }
    }

    const estiloToolBar = {
        background: (estilo.background === 'black') ? 'DarkGrey' : 'darkSeaGreen',
    }
    const logo = (modo === 'oraxulux') ? logoXadnem : logoFrater;
    const colorLetra = (estilo.background === 'black')?'white':'darkslategray';

    return (
        <AppBar style={estiloToolBar} className={'ToolBar'} position="static" sx={{marginTop:'0px'}}>
            <Toolbar sx={{
                display: 'inline-flex',
                width: '100%',
                justifyContent: 'space-around',

            }} disableGutters id={'TB'} style={estiloToolBar}>
                <img
                    src= {logo}
                    alt={'Xadnem'}
                    style={{width: '70px', mx: '1%', marginTop: '5px', marginBottom: '5px'}}
                />
                <Box>
                    <Typography
                        variant="h6"
                        noWrap
                        component="a"
                        href= {modo === 'oraxulux' ? "/?modo=oraxulux":"/?modo=frater"}
                        sx={{
                            fontFamily: 'monospace',
                            fontWeight: 700,
                            letterSpacing: '.3rem',
                            fontSize: '1.8em',
                            color: colorLetra,
                            textDecoration: 'none',
                            marginLeft: 2,
                        }}
                    >
                        {modo === 'oraxulux' ? 'ORAXULUX': ' FRATER Barcelona'}
                    </Typography>
                </Box>
                <Box
                    sx={{display: 'inline-flex', width: '70%', justifyContent: 'center', gap: 10/*,background:'red'*/}}>
                    {paginas.map((page) => (
                        <Button
                            id={page}
                            className={'btBarraSup'}
                            variant={'text'}
                            key={page}
                            onClick={btClicked}
                            sx={{my: 2, fontSize: '1em', color: colorLetra, display: 'block'}}
                        >
                            {page}
                        </Button>
                    ))}
                </Box>
                <Box sx={{
                    disply: 'inline-flex'/*,background:'blue'*/,
                    justifyContent: 'space-around',
                    gap: 5,
                    width: '20%'
                }}>
                    {gadgets && gadgets.map(gadget => gadget)}
                </Box>
            </Toolbar>
        </AppBar>
    );
}
